import { FC } from 'react';
import styled from 'styled-components';
import { u } from '../common/Units';
import BlockContainer from './BlockContainer';
import Image from './Image';

interface BlockBylineProps {
  data: any
}

const BlockBylineWrapper = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
`;

const ProfileImage = styled(Image)`
  width: ${u(55)};
  height: ${u(55)};
  border-radius: 50%;
  margin-right: ${u(11)};

  & img {
    border-radius: 50%;
  }
`;

const Metadata = styled.div`
`;

const Name = styled.span`
  font-weight: 600;
  clear: both;
  display: block;
  margin-bottom: ${u(4)};
`;

const Description = styled.span`
  clear: both;
  display: block;
  margin-bottom: ${u(4)};
`;

/**
 * Render a byline block
 * @returns {JSX.Element} Component template
 */
 export const BlockByline: FC<BlockBylineProps> = ({data}) => {

  if (!data?.name) { return null; }
  if (!data?.prefix) { data.prefix = ""; }

  return (
    <BlockContainer>
      <BlockBylineWrapper>
        {data?.image?.mediaId && (<ProfileImage media={data?.image}/>)}
        <Metadata>
          <Name>{(data?.prefix && String(data?.prefix) + " ") + String(data?.name)}</Name>
          {data?.description && (<Description>{data?.description}</Description>)}
        </Metadata>
      </BlockBylineWrapper>
    </BlockContainer>
  );
}